import React, { useEffect } from "react";
import "./styles.scss";

import { getRiskFallData } from "../../store/homeAction/action";

import { useStateValue } from "../../store/index";
import Button from "../../common/button";
import { useNavigate } from "react-router-dom";

const RiskFall = () => {
  const [{ riskFall }, dispatch] = useStateValue();
  const Navigate = useNavigate();
  useEffect(() => {
    if (Object.keys(riskFall)?.length === 0) {
      dispatch({
        type: "SET_IS_LOADING",
        value: true,
      });
      getRiskFallData((res, error) => {
        dispatch({
          type: "SET_RISKFALL",
          data: res,
        });
        dispatch({
          type: "SET_IS_LOADING",
          value: false,
        });
        if (error) {
          dispatch({
            type: "SET_ALERT_MESSAGE",
            value: true,
            data: {
              severity: "error",
              message: "Something went wrong, Please try again.",
            },
          });
        }
      });
    }
  }, []);

  return (
    <div className="risk-fall-container">
      {Object.keys(riskFall).length !== 0 ? (
        <>
          <h3>{riskFall?.title}</h3>
          <div dangerouslySetInnerHTML={{ __html: riskFall?.description }} />

          <Button
            onClick={() => Navigate(`${process.env.REACT_APP_BASE}/assessment`)}
          >
            {riskFall?.button_text}
          </Button>
        </>
      ) : null}
    </div>
  );
};

export default RiskFall;
